import type { Role, UserDTO } from '@copilot/shared';
import type { UserPatch } from '../api/types';

/** Editable copy of a user row in the Users table (limit kept as text for the input). */
export interface UserDraft {
  name: string;
  role: Role;
  teamId: string;
  active: boolean;
  limit: string;
  cloudSttAllowed: boolean;
}

export function toUserDraft(u: UserDTO): UserDraft {
  return {
    name: u.name,
    role: u.role,
    teamId: u.teamId ?? '',
    active: u.active,
    limit: u.monthlyLimitUsd == null ? '' : String(u.monthlyLimitUsd),
    cloudSttAllowed: u.cloudSttAllowed,
  };
}

/** Only the fields that changed (PATCH semantics), or an error message for invalid input. */
export function userPatchFromDraft(u: UserDTO, d: UserDraft): UserPatch | string {
  const patch: UserPatch = {};
  const name = d.name.trim();
  if (!name) return 'Name is required.';
  if (name !== u.name) patch.name = name;
  if (d.role !== u.role) patch.role = d.role;
  if ((d.teamId || null) !== u.teamId) patch.teamId = d.teamId || null;
  if (d.active !== u.active) patch.active = d.active;
  if (d.cloudSttAllowed !== u.cloudSttAllowed) patch.cloudSttAllowed = d.cloudSttAllowed;
  const limit = d.limit.trim() === '' ? null : Number(d.limit);
  if (limit !== null && (!Number.isFinite(limit) || limit < 0 || limit > 100000)) return 'Limit must be between 0 and 100000.';
  if (limit !== u.monthlyLimitUsd) patch.monthlyLimitUsd = limit;
  return patch;
}
